import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ConfigService } from '../../services/config/config.service'; // Assuming you might need product name

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {
  errorReason: string | null = null;
  productName: string;
  returnUrl: string | null = null;
  returnTitle: string | null = null;
  isPersistentError = false;

  constructor(
    private route: ActivatedRoute,
    private configService: ConfigService,
    private router: Router,
    private location: Location
  ) {
    this.productName = this.configService.config.productName;
  }

  ngOnInit(): void {
    if (history.state) {
      this.returnUrl = typeof history.state.returnUrl === 'string' ? history.state.returnUrl : null;
      this.returnTitle = typeof history.state.returnTitle === 'string' ? history.state.returnTitle : null;
    } else {
      this.returnUrl = null;
      this.returnTitle = null;
    }

    this.route.queryParams.subscribe(params => {
      this.isPersistentError = params['persistent'] === 'true';
      this.errorReason = params['reason'] || 'An unspecified error occurred.';
    });
  }

  goHome(): void {
    this.router.navigate(['/home']);
  }

  goBack(): void {
    if (this.returnUrl) {
      this.router.navigateByUrl(this.returnUrl, { state: { isRetry: true } });
    }
  }
}
